import Clipboard from 'clipboard';

export class Controller {

    /** @ngInject */
    constructor($scope, $uibModal, Alert) {
        this.$scope = $scope;
        this.$uibModal = $uibModal;
        this.Alert = Alert;

    }

    $onInit() {
        new Clipboard(".copyCli").on('success', () => {
            this.$scope.$apply(() => {
            this.Alert('success', 'global.data_copied')
            })
        })
        this.isOidc = this.application.applicationType.oidcConfigSupported;
    }

    showRegenerateModal() {
        this.$uibModal
            .open({
                component: 'companyManageApplicationIntegrationDevelopersAppKeyPasswordRegenerate',
                resolve: {
                    companyId: () => this.companyId,
                    appId: () => this.application.id,
                    isOidc: () => this.isOidc,
                },
            }).result
            .then((value) => this.application.applicationApiPassword = value)
            .then(() => this.Alert('success', 'company.manage-application.integration-developers.app-key-password.regenerate.regenerated'))
    }

    copyToClipboard(text) {
        console.log(text);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/app-key-password/app-key-password.controller.js